import React, { useContext, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

import { Store } from '../../../../Store';
import { toast } from 'react-toastify';
import { getError } from '../../../../utils';
import 'react-toastify/dist/ReactToastify.css';
import LoadingBox from '../../../compoment/LoadingBox';

const GoogleCallbackHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const hasCalled = useRef(false);

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { resentLink } = state;

  const redirectInUrl = new URLSearchParams(location.search).get('redirect');
  const redirect = location.state?.from || redirectInUrl || '/';

  useEffect(() => {
    const fetchGoogleLogin = async () => {
      if (hasCalled.current) return;
      hasCalled.current = true;

      const urlParams = new URLSearchParams(window.location.search);

      if (urlParams) {
        try {
          const { data } = await axios.get(
            `/customer/auth/google/callback?${urlParams.toString()}`
          );

          ctxDispatch({
            type: 'USER_SIGNIN',
            payload: data.data,
          });
          localStorage.setItem('userInfo', JSON.stringify(data.data));
          toast.success('Đăng nhập thành công');
          navigate(
            `${resentLink}#comments`,
            { state: { scrollToComments: true } } || '/'
          );
        } catch (err) {
          toast.error(getError(err));
        }
      }
    };

    fetchGoogleLogin();
  }, [ctxDispatch, redirect, navigate, resentLink]);

  return <LoadingBox text="Đang đăng nhập..." />;
};

export default GoogleCallbackHandler;
